import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// This is a JS component consumed by TSX files. Keep the JSDoc props in sync with
// propTypes so tsgo can type-check callers without treating the component as prop-less.
/**
 * @typedef {React.ImgHTMLAttributes<HTMLImageElement> & {
 *   fallback?: string | (() => React.ReactNode)
 * }} FallbackableImageProps
 */

/** @extends {PureComponent<FallbackableImageProps, { error: boolean }>} */
export class FallbackableImage extends PureComponent {
	static propTypes = {
		fallback: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	};

	state = {
		error: false,
	};

	onError = () => {
		this.setState({ error: true });
	};

	render() {
		const props = Object.assign({}, this.props);
		if ((this.state.error || !props.src) && props.fallback) {
			if (typeof props.fallback === 'string') {
				props.src = props.fallback;
			} else if (typeof props.fallback === 'function') {
				return props.fallback();
			}
		}

		delete props.fallback;

		return <img {...props} alt={props.alt || ''} onError={this.onError} />;
	}
}
